export interface Input extends Marko.SVG.SVG {}

<svg ...input width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
        d="M 2 2 L 18 18 M 2 18 L 18 2"
        stroke="currentColor"
        stroke-width="1.5"/>
</svg>
